'use client'

import { useEffect } from 'react'
import { ThemeProvider } from 'next-themes'
import { DefaultThemes, Themes } from '@/shared/config/theme/lib/theme'
import { migrateTheme } from '@/shared/config/theme/lib/migrate-theme'

export function ThemeProviderWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    migrateTheme()
  }, [])

  return (
    <ThemeProvider attribute="class" defaultTheme={DefaultThemes['light']} enableSystem themes={Themes}>
      {children}
    </ThemeProvider>
  )
}
